import Route from 'route-parser'
import { PUBLISHED_CA_KEY_PICKS } from 'constants/requests'
import { URL_CA_KEY_PICK_ARTICLE } from 'constants/urls'
import { fetch } from 'services/ApiService'

export const publishedCaKeyPicks = ({ aol }) => fetch(PUBLISHED_CA_KEY_PICKS, { aol })

export const keyPickUrl = (id, aol) => new Route(URL_CA_KEY_PICK_ARTICLE).reverse({ aol, id })
